import {httpGet} from "@/utils/http";

export const getConfigSystem = () => {
    return httpGet(`/api/config/system`);
};
// 系统公告
export const getConfigNotice = () => {
    return httpGet(`/api/config/notice`);
};
// 验证码
export const getCaptcha = () => {
    return httpGet(`/api/captcha/get`);
};
// 菜单列表
export const getMenuList = () => {
    return httpGet(`/api/menu/list`);
};